import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  LabelList,
} from "recharts";

const ROW_HEIGHT = 26;

const toNumber = (v) => {
  if (v === null || v === undefined) return 0;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

const TiposEmbalagensChart = ({ data = [], height, color = "#5cb85c" }) => {
  const normalized = useMemo(() => {
    return (data || [])
      .map((d) => ({
        ...d,
        name: String(d?.name || "").trim() || "NÃO INFORMADO",
        value: toNumber(d?.value),
      }))
      .sort((a, b) => b.value - a.value);
  }, [data]);

  const dynamicHeight = useMemo(() => {
    const base = 110;
    return Math.max(240, base + normalized.length * ROW_HEIGHT);
  }, [normalized.length]);

  return (
    <ResponsiveContainer width="100%" height={height ?? dynamicHeight}>
      <BarChart
        data={normalized}
        layout="vertical"
        margin={{ top: 10, right: 35, left: 160, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis
          type="category"
          dataKey="name"
          width={180}
          interval={0}
          tick={{ fontSize: 11 }}
        />
        <Tooltip
          formatter={(val) => [`${val} ocorrências`, "Qtd."]}
          labelFormatter={(label) => `Tipo de Embalagem: ${label}`}
        />
        <Bar dataKey="value" fill={color} radius={[0, 5, 5, 0]}>
          <LabelList dataKey="value" position="right" fontSize={11} fill="#333" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TiposEmbalagensChart;
